module.exports = __webpack_public_path__ + "static/media/academia-img3.e85a2e99.svg";